import {
  useEffect,
  useState
} from "react";

import {
  useLocation,
  useNavigate
} from "react-router-dom";

import API from "../../services/api";

function AddMoney() {

  const navigate =
    useNavigate();

  const location =
    useLocation();

  const isWithdraw =
    location.pathname.includes(
      "withdraw"
    );

  const walletId =
    new URLSearchParams(
      location.search
    ).get("id");

  const [wallet,
    setWallet] =
    useState(null);

  const [form,
    setForm] =
    useState({
      amount: "",
      description: ""
    });

  useEffect(() => {

    loadWallet();

  }, []);

  const loadWallet =
    async () => {

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        const res =
          await API.get(
            "/wallets",
            {
              headers: {
                Authorization:
                  `Bearer ${token}`
              }
            }
          );

        const selected =
          res.data.wallets.find(
            w =>
              Number(w.id) ===
              Number(walletId)
          );

        setWallet(
          selected
        );

      } catch (err) {

        console.log(err);

      }

    };

  const submit =
    async (e) => {

      e.preventDefault();

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        await API.post(

          isWithdraw
            ? "/wallets/withdraw"
            : "/wallets/add-money",

          {
            wallet_id:
              walletId,

            amount:
              form.amount,

            description:
              form.description
          },

          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }

        );

        navigate(
          "/admin/wallets"
        );

      } catch (err) {

        console.log(err);

        alert(
          err.response?.data
            ?.message ||
          "Something went wrong"
        );

      }

    };

  if (!wallet) {

    return (
      <div>
        Loading...
      </div>
    );

  }

  return (

    <div>

      <h1
        className="
        text-4xl
        font-bold
        mb-8
        "
      >
        {
          isWithdraw
            ? "Withdraw Money"
            : "Add Money"
        }
      </h1>

      <form
        onSubmit={submit}
        className="
        bg-[#111]
        rounded-2xl
        p-8
        max-w-2xl
        "
      >

        <div
          className="
          mb-6
          "
        >

          <label
            className="
            block
            mb-2
            "
          >
            Wallet
          </label>

          <input
            disabled
            value={
              wallet.wallet_name
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />

        </div>

        <div
          className="
          mb-6
          "
        >

          <label
            className="
            block
            mb-2
            "
          >
            Current Balance
          </label>

          <input
            disabled
            value={
              `₹${Number(wallet.balance).toFixed(2)}`
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            text-green-400
            border
            border-yellow-500/20
            "
          />

        </div>

        <div
          className="
          mb-6
          "
        >

          <label
            className="
            block
            mb-2
            "
          >
            Amount
          </label>

          <input
            type="number"
            required
            min="1"
            value={
              form.amount
            }
            onChange={(e)=>
              setForm({
                ...form,
                amount:
                  e.target.value
              })
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />

        </div>

        <div
          className="
          mb-8
          "
        >

          <label
            className="
            block
            mb-2
            "
          >
            Description
          </label>

          <textarea
            rows="4"
            value={
              form.description
            }
            onChange={(e)=>
              setForm({
                ...form,
                description:
                  e.target.value
              })
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />

        </div>

        <div
          className="
          flex
          gap-3
          "
        >

          <button
            type="submit"
            className={`
            px-6
            py-3
            rounded-xl
            font-semibold
            ${
              isWithdraw
                ? "bg-red-500"
                : "bg-green-500"
            }
            `}
          >
            {
              isWithdraw
                ? "Withdraw"
                : "Add Money"
            }
          </button>

          <button
            type="button"
            onClick={()=>
              navigate(
                "/admin/wallets"
              )
            }
            className="
            px-6
            py-3
            rounded-xl
            bg-gray-700
            "
          >
            Cancel
          </button>

        </div>

      </form>

    </div>

  );

}

export default AddMoney;